import DocumentsPage from './documents';

export default DocumentsPage;
